import { buildURL, request, logout } from "@/api";

const defaultState = {
  auth2: null,
  currentUser: null
};

const getters = {
  currentUser: state => state.currentUser,
  isSignedIn: state => state.currentUser && state.currentUser.id,
  currentRole: (state, getters, rootState, rootGetters) => {
    if (!rootGetters["spaces/active"]) return;
    const spacePermissions = rootGetters["spaces/active"].user_permissions;
    const currentUserId = state.currentUser.id;
    const permission = spacePermissions.find(p => p.user_id === currentUserId);
    return permission && permission.role;
  },
  isOwner: (state, getters) => getters.currentRole === "owner",
  isAdmin: (state, getters) =>
    getters.isOwner || getters.currentRole === "admin"
};

const mutations = {
  setCurrentUser: (state, currentUser) => {
    state.currentUser = currentUser;
  },
  addSpace: (state, spaceId) => {
    state.currentUser.space_ids.push(spaceId);
  },
  removeSpace: (state, spaceId) => {
    const spaceIds = state.currentUser.space_ids;
    var index = spaceIds.indexOf(spaceId);
    if (index >= 0) {
      spaceIds.splice(index, 1);
    }
  }
};

const actions = {
  authorize: async (store, invite) => {
    let query = invite && { invite };
    let url = buildURL({ type: "oauth/authorize", query });
    const res = await request("POST", url);
    window.location = res.redirect_uri;
  },
  fetchCurrentUser: ({ dispatch, commit }) => {
    let url = buildURL({ type: "users", id: "me" });
    return request("GET", url)
      .then(res => {
        const currentUser = { space_ids: [], ...res["data"] };
        commit("setCurrentUser", currentUser);
      })
      .catch(err => {
        const code = err.response && err.response.status;
        code === 401 && dispatch("snackError", "Unauthenticated");
        dispatch("logout");
      });
  },
  logout: async ({ dispatch, commit }) => {
    commit("setCurrentUser", {});
    dispatch("clearStore");
    return logout();
  }
};

export default {
  namespaced: false,
  state: defaultState,
  getters,
  actions,
  mutations
};
